import { render } from "./IntroSection.vue?vue&type=template&id=5c942ac9&scoped=true"
import script from "./IntroSection.vue?vue&type=script&lang=js"
export * from "./IntroSection.vue?vue&type=script&lang=js"

import "./IntroSection.vue?vue&type=style&index=0&id=5c942ac9&scoped=true&lang=css"

import exportComponent from "/Users/bellakwon/Desktop/thesis01/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c942ac9"]])

export default __exports__